import { Box, Portal, SpringValue } from '@bcp-nextgen-dx-component-factory/design-system';

export const ArcChartTooltip: React.FC<
	React.PropsWithChildren<{
		arrowSize: number;
		top: SpringValue<number>;
		left: SpringValue<number>;
		display: SpringValue<string>;
	}>
> = ({ children, arrowSize, ...spring }) => {
	return (
		<Portal visible>
			<Box.Animated
				style={
					{
						...spring,
					} as any
				}
				styles={{
					transform: 'translate(-50%, -100%)',
					justifyContent: 'center',
					flexDirection: 'column',
					position: 'absolute',
				}}
			>
				<Box
					styles={{
						borderRadius: 16,
						background: '#2E3641',
						minWidth: arrowSize * 6,
						minHeight: arrowSize * 6,
						justifyContent: 'center',
						alignItems: 'center',
						padding: '12px 16px',
					}}
				>
					{children}
				</Box>
				<Box styles={{ position: 'relative', justifyContent: 'center' }}>
					<Box
						web={{
							styles: {
								transform: 'rotate(45deg)',
							},
						}}
						styles={{
							background: '#2E3641',
							width: arrowSize * 2,
							height: arrowSize * 2,
							position: 'absolute',
							top: -arrowSize,
						}}
					/>
				</Box>
			</Box.Animated>
		</Portal>
	);
};
